import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { cn } from '../lib/utils';
import { phases, tools } from '../data/system';
export function SystemBlueprint() {
  return <section aria-label="Le système complet de préparation en 6 volumes" className="bg-navy text-white" data-id="element-254" data-mp="29suzwibq7hwf">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-24" style={{
      paddingTop: "20px",
      paddingBottom: "28px"
    }} data-id="element-255" data-mp="24u0hhhho7vcu">
        <div className="mx-auto max-w-3xl text-center" data-id="element-256" data-mp="1zx9zgomb2pos">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-aqua" data-id="element-257" data-mp="1vtlu8cl5c66p">
            Découvrez le système triathlon longue distance™
          </p>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[0.95] sm:text-6xl" data-id="element-258" data-mp="1qx4wcqo5adgf">
            Le système complet de préparation en 6 volumes
          </h2>
          <p className="mt-5 text-lg text-white/70" data-id="element-259" data-mp="3l8jmv9ozcgx8">
            Un seul système pour organiser votre parcours, de l'entraînement jusqu'à la ligne d'arrivée.
          </p>
          <p className="mt-3 text-base font-semibold text-white" data-id="element-260" data-mp="ywbuqfrrf08l">Le programme structuré en 6 phases</p>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-261" data-mp="12yyh415nvsye">
          {phases.map((p, idx) => {
          const Icon = p.icon;
          return <motion.article key={p.n} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.3,
            delay: idx % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex h-full flex-col rounded-2xl border border-white/10 bg-obsidian/60 p-6" data-id="element-262" data-mp="p0qqeaz7xnvo" data-mpi={idx}>
                <div className="flex items-center justify-between" data-id="element-263" data-mp="1cw36e9ut04jf">
                  <span className="font-display text-5xl font-extrabold leading-none text-electric" data-id="element-264" data-mp="1cu9ykr8gfe9u">{p.n}</span>
                  <Icon className="h-6 w-6 text-aqua" aria-hidden="true" data-id="element-265" data-mp="20k49325awqqx" />
                </div>
                <div className="mt-4 flex gap-1" aria-hidden="true" data-id="element-266" data-mp="25egwtodt8o8h">
                  {phases.map((_, k) => <span key={k} className={cn('h-1 flex-1 rounded-full', k < idx ? 'bg-perf' : k === idx ? 'bg-electric' : 'bg-white/10')} data-id="element-267" data-mp="2f6jq01gu7z1n" data-mpi={k} />)}
                </div>
                <h3 className="mt-5 font-display text-2xl font-extrabold uppercase leading-tight" data-id="element-268" data-mp="2595ca9matod1">{p.name}</h3>
                <p className="mt-2 font-semibold leading-snug text-white" data-id="element-269" data-mp="218bnle1185j3">{p.lead}</p>
                <p className="mt-2 text-sm leading-relaxed text-white/65" data-id="element-270" data-mp="1wajx8og1crh0">{p.desc}</p>
                <p className="mt-4 text-xs font-bold uppercase tracking-wider text-white/50" data-id="element-271" data-mp="1ris1lzi0vvk0">Vous découvrirez comment :</p>
                <ul className="mt-2 space-y-1.5" data-id="element-272" data-mp="1mki7ztby530i">
                  {p.learn.map(l => <li key={l} className="flex items-start gap-2 text-sm leading-snug text-white/80" data-id="element-273" data-mp="1hlnf1yk9ly2o">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-perf" strokeWidth={3} aria-hidden="true" data-id="element-274" data-mp="1djk2t7prupgc" />
                      {l}
                    </li>)}
                </ul>
                <p className="mt-auto pt-5 text-xs font-semibold uppercase tracking-wider text-white/45" data-id="element-275" data-mp="3k82iwdfieogj">
                  Phase {p.n} sur 06
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-14" data-id="element-276" data-mp="3t7zekz0bgnl3">
          <p className="text-center font-display text-2xl font-extrabold uppercase sm:text-3xl" data-id="element-277" data-mp="3t90pn3hc1a2t">
            Plus 4 outils pratiques
          </p>
          <p className="mt-2 text-center text-sm text-white/60" data-id="element-278" data-mp="31hbb3gb67649">
            Tout est pensé pour vous aider à organiser les différentes dimensions de votre préparation.
          </p>
          <ol className="mt-8 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-279" data-mp="3ahq0orv637dk">
            {tools.map(({
            verb,
            name,
            desc,
            icon: Icon
          }) => <li key={verb} className="flex flex-col gap-3 bg-navy p-5" data-id="element-280" data-mp="2hs0ywcamv3aw">
                <Icon className="h-5 w-5 text-electric" aria-hidden="true" data-id="element-281" data-mp="2mrvqki28fwx0" />
                <p className="font-display text-2xl font-extrabold uppercase leading-none sm:text-3xl" data-id="element-282" data-mp="2mpsr77f6wrfm">{verb}</p>
                <p className="text-sm font-semibold leading-snug text-white" data-id="element-283" data-mp="oabo3gx8iwn4">{name}</p>
                <p className="text-sm leading-snug text-white/60" data-id="element-284" data-mp="o8ije766mmhr">{desc}</p>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}